export default "__VITE_ASSET__dha2r62v__"